if (!customElements.get('lorelie-service-slider')) {
  customElements.define('lorelie-service-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lorelie-service__grid');
      this.slides = [...this.querySelectorAll('.lorelie-service__item')];
      this.buttons = [...this.querySelectorAll('.lorelie-service__dot')];
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), options));
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('.lorelie-service__item'));
        if (index >= 0 && matchMedia('(max-width: 749px)').matches) this.goTo(index);
      }, options);
      this.update();
    }
    goTo(index) {
      const left = this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const left = this.track.getBoundingClientRect().left;
      let active = 0;
      this.slides.forEach((slide, index) => {
        if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[active].getBoundingClientRect().left - left)) active = index;
      });
      this.buttons.forEach((button, index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
